﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadComponentField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadComponentField, eOutputFieldType.cadComponent)
export class CadComponentField extends OutputField implements ICadComponentField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: string;
    public suppressed: boolean;
    public deleted: boolean;
    public newFileName: string;
    public partFamilyName: string;
    public newPartFamilyName: string;
    public material: string;
    public customMaterialDatabase: string;
    public fileNameWithExtension: string;
    public filePath: string;
}
